import React from 'react';
import { Divider, Typography } from 'antd';

const { Title } = Typography;
const facebookPage = 'https://www.facebook.com/rsgcrl.pu';
const facebookEmbed = `https://www.facebook.com/plugins/page.php?href=${encodeURIComponent(facebookPage)}&tabs=timeline&width=450&height=630&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true`;

const SocialFeed = () => (
  <section className="sarl-social-section" aria-labelledby="rsgcrl-social-title">
    <div className="sarl-social-inner">
      <Title level={2} id="rsgcrl-social-title" className="sarl-social-title">Social Feed</Title>
      <Divider className="ncgsa-divider" />
      <div className="sarl-facebook-frame-wrap">
        <iframe
          title="Remote Sensing, GIS and Climatic Research Lab Facebook feed"
          src={facebookEmbed}
          className="sarl-facebook-frame"
          width="450"
          height="630"
          scrolling="no"
          frameBorder="0"
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          loading="lazy"
        />
      </div>
      <a
        href={facebookPage}
        target="_blank"
        rel="noreferrer"
        className="sarl-facebook-fallback"
      >
        View RSGCRL on Facebook
      </a>
    </div>
  </section>
);

export default SocialFeed;
